import "./FAQs.css";

const FAQs = () => {
  return (
    <div className="documentation__body">
      <div className="document-title">
        <h1>Frequently Asked Questions (FAQs)</h1>
        <p>
          In this section, we address some common questions about Queekk to
          provide clarity and assistance to users.
        </p>
      </div>

      <div className="documentation__content">
        <div className="custom-faqs__content">
          <ol>
            <li>
              <strong>What is Queekk?</strong>
              <p>
                Queekk is an AI-powered chat assistant designed to provide instant
                support and assistance to users on websites. It leverages natural
                language processing technology to understand user queries and
                deliver accurate responses in real-time.
              </p>
            </li>
            <li>
              <strong>How does Queekk work?</strong>
              <p>
                Queekk integrates seamlessly into websites using a simple script
                tag. Once integrated, users can interact with Queekk via the chat
                interface to ask questions, seek assistance, or receive
                recommendations. Queekk utilizes advanced algorithms to analyze
                user inputs and provide relevant responses.
              </p>
            </li>
            <li>
              <strong>Can I customize Queekk's appearance and behavior?</strong>
              <p>
                Yes, Queekk offers various customization options to tailor its
                appearance and behavior to your website's branding and
                requirements. You can customize the theme, set introductory
                messages, configure key presses to open Queekk, and define main
                colors.
              </p>
            </li>
            <li>
              <strong>Is Queekk suitable for my industry or business?</strong>
              <p>
                Queekk is suitable for a wide range of industries and businesses,
                including e-commerce platforms, educational websites,
                service-based businesses, and informational websites. Whether
                you're a small business or a large enterprise, Queekk can help
                enhance your customer support experience.
              </p>
            </li>
            <li>
              <strong>How can I get started with Queekk?</strong>
              <p>
                To get started with Queekk, simply sign up for an account,
                integrate Queekk into your website using the provided script tag,
                and customize Queekk's settings to match your preferences. Refer
                to the documentation for detailed instructions on installation,
                integration, and usage.
              </p>
            </li>
            <li>
              <strong>Is Queekk free to use?</strong>
              <p>
                Yes, Queekk offers a free plan that allows you to integrate the
                chat assistant into your website and access basic features.
                However, for advanced customization options and premium support,
                you may opt for a paid plan.
              </p>
            </li>
            <li>
              <strong>
                Can I get support if I encounter issues with Queekk?
              </strong>
              <p>
                Yes, Queekk provides support resources, including documentation,
                forums, and a dedicated support team, to assist users with any
                issues they may encounter. Feel free to reach out to Queekk's
                support team for assistance or browse the documentation for
                solutions to common problems.
              </p>
            </li>
            <li>
              <strong>Is Queekk available in multiple languages?</strong>
              <p>
                Yes, Queekk supports multiple languages, allowing users to
                interact with the chat assistant in their preferred language. You
                can configure Queekk to recognize and respond to user inputs in
                various languages to cater to a diverse audience.
              </p>
            </li>
            <li>
              <strong>How can I optimize Queekk for better performance?</strong>
              <p>
                To optimize Queekk for better performance, ensure that your
                website's hosting environment can handle the load generated by
                Queekk. Additionally, minimize the number of scripts and resources
                loaded on the page to improve responsiveness and speed.
              </p>
            </li>
            <li>
              <strong>Can I use Queekk on mobile devices?</strong>
              <p>
                Yes, Queekk is designed to be mobile-responsive and can be used on
                various devices, including smartphones and tablets. Users can
                access Queekk's chat interface seamlessly on any device, providing
                a consistent support experience across different platforms.
              </p>
            </li>
          </ol>
        </div>
      </div>

      <div className="last__page">
        <p>
          If you have any additional questions or concerns about Queekk, don't
          hesitate to reach out to our support team for assistance. We're here
          to help you make the most of Queekk and enhance your customer support
          experience.
        </p>
      </div>
    </div>
  );
};

export default FAQs;
